module.exports = __webpack_public_path__ + "static/media/transparent-colored.6476c6ec.png";